export enum DispatchStatuses {
  'Dispatched' = 'Dispatched',
  'InFlight' = 'In-Flight',
  'Landed' = 'Landed',
  'Cancelled' = 'Cancelled',
  'Completed' = 'Completed',
}

export enum DispatchListTab {
  All,
  Dispatched,
  InFlight,
  Landed,
  Cancelled,
  Completed,
}
